import axios from 'axios'
import { encryptMD5 } from '@/utils'
// 创建上传图片实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  responseType: 'json',
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})
service.interceptors.request.use(
  config => {
    let key = process.env.VUE_APP_SERVER_KEY
    let signType = process.env.VUE_APP_SIGN_TYPE
    let timestamp = Math.round(new Date().getTime() / 1000).toString()
    let sign = encryptMD5(key + '&' + signType + '&' + timestamp)

    const data = {
      'channel': 3,
      'sign': sign,
      'timestamp': timestamp
    }

    if (config.method === 'post') {
      config.params = data
    //   config.data = JSON.stringify(config.data)
    } else {
      config.params = {
        ...config.params,
        ...data
      }
    }
    return config
  },
  error => {
    // 请求错误预处理
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    let msg = ''
    if (res.success) {
      return Promise.resolve(res.resultData)
    } else {
      switch (res.errCode) {
        case 209: // 重新登录
          location.href = ''
          break
        case 500: // 系统异常
          msg = '系统异常，请稍后重试'
          break
        default:
          msg = res.errMessage
      }
    }
    return Promise.reject(msg)
  },
  error => {
    // Toast.clear()
    // TODO: 连接超时 需要判断
    return Promise.reject(error)
  }
)
/**
 * @description: post请求
 * @param {type}
 * @return: promise
 */

export function upload (url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}
